// eslint-disable-next-line import/no-unresolved
import { Client } from '@stomp/stompjs';
import { getBrokerUrl } from './getBrokerUrl';
import { Token } from '../Token';
import { AgreementWaitingForContract } from '../../storage/agreements/agreements.model';
import { EMPTY_ARRAY_LENGTH } from '../consts';
import { apiEvents, appEvents, events } from './Api';

export const client = new Client({
  reconnectDelay: 200
});

export const webSocketsConnection = () => {
  client.brokerURL = getBrokerUrl();
  client.forceBinaryWSFrames = true;
  client.beforeConnect = () => {
    client.connectHeaders = {
      Authorization: Token.getBearer(),
      'Content-Type': 'application/json'
    };
  };
  client.onConnect = () => {
    client.subscribe('/listen/event/PRODUCT_DOCUMENT_READY', (response) => {
      const data: AgreementWaitingForContract[] | [] = JSON.parse(
        response.body
      );
      if (!data) {
        client.deactivate();
        events.emit(appEvents.CLEAR_TIMEOUT);
      }

      if (data.length === EMPTY_ARRAY_LENGTH) {
        events.emit(apiEvents.WSS_DOCUMENT_GENERATION, { data });
        client.deactivate();
        events.emit(appEvents.CLEAR_TIMEOUT);
      }

      if (data && data.length > EMPTY_ARRAY_LENGTH) {
        const areAllDocumentsGenerated = data.every(
          (agreement: AgreementWaitingForContract) => agreement.documentReady
        );
        events.emit(apiEvents.WSS_DOCUMENT_GENERATION, { data });

        if (areAllDocumentsGenerated) {
          client.deactivate();
          events.emit(appEvents.CLEAR_TIMEOUT);
        }
      }
    });
  };
  client.onStompError = (err) => {
    console.log('Stomp error:', err);
  };
  client.onWebSocketError = (err) => {
    console.log('Web socket error: ', err);
  };
  client.activate();
  events.on(apiEvents.WSS_CLOSE_CONNECTION, () => client.deactivate());
};
